import {validateEmail} from '@/helpers'

export default {
    name: 'support',
    data() {
        return {
            items: [],
            loaded: false,
            sent_success: false,
            site_name: window.APP_CONFIG.DOMAIN_NAME,
            image_address: window.APP_CONFIG.IMAGE_ADDRESS,
            host_name: window.APP_CONFIG.DOMAIN_URL,
            open_info: false,
            disable_name: false,
            disable_email: false,
            open_form: false,
            contact_formdata: {
                name: {
                    val: '',
                    error_msg: ''
                },
                subject:  {
                    val: '',
                    error_msg: ''
                },
                email:  {
                    val: '',
                    error_msg: ''
                },
                email_repeat:  {
                    val: '',
                    error_msg: ''
                },
                message:  {
                    val: '',
                    error_msg: ''
                },
                'g-recaptcha-response': {
                    val: '',
                    error_msg: ''
                }
            },
        }
    },
    methods: {
        submit() {
            this.sent_success = false
            this.validateContactForm()
            if(!this.canSubmit) {
                window.scrollTo(0, this.$refs['contact-form'].offsetTop)
                return;
            }

            let formdata = {}
            for(let key in this.contact_formdata) {
                formdata[key] = this.contact_formdata[key].val
            }

            this.$store.dispatch('pub/sendSupportMessage', formdata)
                .then(res => {
                    this.clearContactForm()
                    this.sent_success = true
                })
        },
        verifyRecaptcha(response) {
            this.contact_formdata['g-recaptcha-response'].val = response
            this.contact_formdata['g-recaptcha-response'].error_msg = ''
        },
        validateInput(e, key) {
            let s_val = e ? e.target.value : this.contact_formdata[key].val
            let error_msg = ''

            if(!s_val) {
                switch(key) {
                    case 'name': error_msg = 'Invalid Username'; break;
                    case 'subject': error_msg = 'Please enter subject'; break;
                    default: error_msg = 'This field is required'; break;
                }
            } else {
                if(key == 'subject' && s_val.length < 10) {
                    error_msg = 'Please enter at least 10 characters'
                }
            }

            if(key.indexOf('email') !== -1) {
                if(key == 'email_repeat' && this.contact_formdata[key].val !== this.contact_formdata['email'].val) {
                    error_msg = 'Emails did not match'
                }

                if(!validateEmail(this.contact_formdata[key].val)) {
                    error_msg = 'Enter valid email'
                }
            }

            this.contact_formdata[key].error_msg = error_msg
        },
        validateContactForm() {
            for(let key in this.contact_formdata) {
                let e = {
                    target: {
                        value: this.contact_formdata[key].val
                    }
                }
                this.validateInput(e, key)
            }
        },
        clearContactForm() {
            this.$refs['recaptcha'].reset()
            for(let key in this.contact_formdata) {
                this.contact_formdata[key].val = ''
            }
        },
        appendItem() {
            //append item use for overloading
            console.log('appending')
        }
    },
    computed: {
        isAuthenticated() {
            return this.$store.getters['auth/isAuthenticated']
        },
        showDesktop() {
            return this.$root.$children[0].width > 1199
        },
        canSubmit() {
            for(let key in this.contact_formdata) {
                if(this.contact_formdata[key].error_msg)
                    return false
            }
            return true
        },
        userProfile() {
            return this.$store.getters['auth/profile']
        }
    },
    mounted() {
        this.$store.dispatch('pub/getContactItems')
            .then(res => {
                this.items = res.data.data
                this.loaded = true
                this.appendItem()
            })

         if(this.$route.params.openForm) {
            this.open_form = true
            setTimeout(() => {
                window.scrollTo(0, this.$refs['contact-form'].offsetTop)
            }, 1000)
         }

        if(this.$store.getters['auth/isAuthenticated']) {
            this.disable_email = true
            this.disable_name = true
            this.contact_formdata.name.val = this.userProfile['nick_name']
            this.contact_formdata.email.val = this.userProfile['email']
            this.contact_formdata.email_repeat.val = this.userProfile['email']
        }
    }
}
